import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const StorePageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.stores,
      component: React.lazy(() => import('./StorePage')),
    },
    {
      path: routesUrl.storeItem,
      exact: true,
      component: React.lazy(() => import('./StoreDetailPage')),
    },
    {
      path: routesUrl.storeOpinions,
      component: React.lazy(() => import('./StoreOpinionsPage')),
    },
  ],
};

export default StorePageConfig;
